





































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "LegendItem"
})
export default class LegendItem extends Vue {
  // ===== Store ===== //

  // ===== Props ===== //
  @Prop({ default: "" }) public readonly name?: string;
  @Prop({ default: "" }) public readonly description?: string;
  @Prop({ default: "blue" }) public readonly iconColor?: string;
  @Prop({ default: "" }) private readonly image?: string;
  @Prop({ default: "" }) public readonly icon?: string;
  @Prop({ default: true }) private readonly switchValue!: boolean;
  // ===== Data ===== //

  // ===== Methods ===== //
  public getImage(): string {
    return this.image ? require(`../../../assets/${this.image}.png`) : "";
  }
  // ===== Computed ===== //
  get kebabName(): string {
    return this.name ? this.name.replace(" ", "-").toLowerCase() : "";
  }

  get switchToggle(): boolean {
    return this.switchValue;
  }
  set switchToggle(newVal: boolean) {
    /* istanbul ignore next */
    this.$emit("switchToggled", newVal);
  }
  // ===== Lifecycle Hooks ===== //
}
